import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { useLocation } from "react-router-dom";
import ChatMessagesTable from "../../components/ChatList/ChatList";

const Chat = () => {
    const location = useLocation();
    const { uid, otherUser } = location.state || {};
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Chat" />
                <ChatMessagesTable
                    defaultUid={uid}
                    defaultOtherUser={otherUser}
                />
            </MasterLayout>
        </>
    );
};

export default Chat;
